//@ts-nocheck
import { React, useState, useEffect } from "react";
import { FiUser } from "react-icons/fi";
import { getUrlElement } from './../../utils/common';
import FtvIcon, { ftvIcon } from '../../utils/FtvIcon';
import Linkify from 'react-linkify';
import moment from 'moment';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import PostbackButton from "../PostBackButtons/PostBackButtons";
import RichMediaUpload from "../RichMediaUpload/RichMediaUpload";
import DOBInputSeparate from "../RichMediaDOB/RichMediaDOB";
import UsernameInput from "../RichmediaUsername/RichmediaUsername";
const MessageComponent = styled.div `
    padding: 0 12px;
    margin: 10px 0;
    font-family: 'Nunito', sans-serif;
    display: flex;
    align-items: center;
    color: #000;
    ${props => props.isCustomer && css`
        position: relative;
        flex-direction: row-reverse;
    `}
    ${props => props.isEvent && css`
        position: relative;
        flex-direction: row-reverse;
        width: 100%
        margin: 0;
    `}
`

const MessageBody = styled.div`
padding-right: 45px;
padding-left: 10px;
overflow: hidden;
text-overflow: ellipsis;
word-break: break-word;
width: calc(100% - 50px);
text-align: left;
${props => props.isCustomer && css`
    align-items: end;
    display: flex;
    flex-direction: column;
    padding-left: 45px;
    padding-right: 10px;
`}

.date-time {
    font-size: 11px;
    color: #7e7e7e;
    font-style: italic;
}

`

const EventBody = styled.div`
        
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #dddddd;
        line-height: 0.1em;
        margin: 10px 0 20px;

`
const RichMedia = styled.div`
        
    display: flex;
    flex-flow: column;
    width: auto;
    text-align: left;
    /* margin: 10px 0 20px; */
    background: #e5e5ea;
    padding: 12px;
    border-radius: 12px;
    margin: 12px 12px 0 12px;
`

const EventText = styled.div`
        font-size: 11px;
        color: #7e7e7e;
        font-style: italic;
        display: initial;
        padding-left: 10px;
        padding-right: 10px;
        background: #fff;

`
const EventTime = styled.div`
    font-size: 11px;
    color: #7e7e7e;
    font-style: italic;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`


const MessageBodyContainer = styled.div`
    white-space: pre-line;
    display: inline-block;
    background-color: var(--chat-client-grey-light);
    padding: 12px;
    border-radius: 12px;
    border-top-left-radius: 0;
    ${props => props.isCustomer && css`
        color: #fff;
        background-color: var( --chat-client-grey-dark);
        border-top-left-radius: 12px;
        border-top-right-radius: 0;
    `}
    a{
        color: var(--chat-client-blue-light);
    }

`

const MessageWrapper = styled.div`
    flex-wrap: wrap;
    display: flex;
    ${props => props.isCustomer && css`
        display: contents;
    `}
    ${props => props.isEvent && css`
        width: 100%;
    `}
`

const MessageAvatar = styled.div`
    width: 50px;
    align-self: stretch;
    @media (max-width: 768px) {
        width: 30px;
    }
    div{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: var(--chat-client-grey-light);
        @media (max-width: 768px) {
            width: 30px;
            height: 30px;
        }
    }
`

const MessageName = styled.div`
    color: #6c6c6c;
    display : block;
    padding-right: 45px;
    padding-left: 10px;
    padding-bottom: 3px;
    font-size: 11px;
    font-style: italic;
`

const Message = ({message, previousMessageType})=>{

    // console.log(message);
    const [replied, setReplied] = useState(false);
    // const replied = false;
    let brand = getUrlElement(4);

    let isFtv = (brand == 'ftv') ? true : false;
    const isCustomer = (message.senderParticipantType === "CUSTOMER")
    const isEvent = (message.senderType === "PARTICIPANT_ADDED") || (message.senderType === "PARTICIPANT_REMOVED")
    const isRichMediaMessage = ((message.body.richMediaPayload) && message.senderParticipantType == "SYSTEM");
    const isRichMediaReply = ((message.body.richMediaPayload) && message.senderParticipantType == "CUSTOMER" && message.body.elementType === "reply");
    const isRichMediaReplyCustom = (message.senderParticipantType == "CUSTOMER" && 
                                   message.body.elementText && 
                                   message.body.elementText.text && 
                                   previousMessageType === "RICH_MEDIA");
    let isImage = isRichMediaMessage && (message.body.elementType == 'image');
    console.log(isImage, "IMAGEEEEEE");
    let isChip = isRichMediaMessage && (message.body.elementType == 'chips');
    let isDOB = isRichMediaMessage && (message.body.elementType == 'inputDate');
    let isInputText = isRichMediaMessage && (message.body.elementType == 'inputText');

    let actionList = null;
    if (isRichMediaMessage) {
        actionList = message.body.richMediaPayload.actions;
    }

    useEffect(() => {
        console.log("********************");
        console.log(isRichMediaReply || isRichMediaReplyCustom);
        if (isRichMediaReply || isRichMediaReplyCustom) {
            // Select buttons within the current message
            const dafabetButtons = document.getElementsByClassName('dafabet');
            console.log(")))))))))))))))))))))))");
            console.log(dafabetButtons);
            console.log(")))))))))))))))))))))))");
            Array.from(dafabetButtons).forEach(button => {
                button.setAttribute('disabled', true);
            });
        }
    }, [isRichMediaReply, isRichMediaReplyCustom, replied]);
    
    /*
    if (isRichMediaReply && replied !== true) {
        // Select all buttons with class "dafabet"
        const dafabetButtons = document.getElementsByClassName('dafabet');
        
        // Loop through each button and disable it
        Array.from(dafabetButtons).forEach(button => {
            button.setAttribute('disabled', true);
        });
    }*/
    
    console.log(isRichMediaMessage);

    const [loading, setLoading] = useState(true);
  
    const { ui } = useSelector(state=>state)
    const config = ui?.config?.attributes;
    // config?.appChatBox.attachmentFailureMessageTitle

    const handleLink = (e)=>{
        let target = e.target;
        e.preventDefault()
        if(target.tagName?.toLowerCase() === "a"){
        window.open(target.href,"_blank")
        }
    }


    const messageProps = {
        onClick:handleLink,
        'aria-label':message.body.elementText.text,
        isCustomer:isCustomer

    }
    
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    var timeStamp = new Date(message.receivedAt).getTime();

    if(isEvent) {
    var timeStamp = message.lastUpdatedTimestamp;
    }

    var dateString = moment(timeStamp).format("MM/DD/YYYY, H:mm:ss");
    var timeString = moment(timeStamp).format("H:mm:ss");

    return (
    <MessageComponent  isCustomer={isCustomer} isEvent={isEvent} >

        {/* {JSON.stringify(message)} */}
        {!(isCustomer || isEvent)?<MessageAvatar className="message-avatar">
            {(isFtv)?
            <div>
            <FtvIcon/>
            </div>:
            <div>
                <FiUser size="20" />
            </div>
            }
        </MessageAvatar>:null}
        <MessageWrapper isCustomer={isCustomer}  isEvent={isEvent} >
        {!isCustomer?<MessageName>
            <div>
                {message.senderParticipantName}
                {message.senderParticipantName ? " " + timeString : null}
            </div>
        </MessageName>:null}

        {!isEvent?<MessageBody  className="msg-body" isCustomer={isCustomer}>
            { isCustomer? <div className="date-time">{timeString}</div> : null }
            {
                message.body.elementText.textFormat === 'PLAINTEXT'?
                <MessageBodyContainer {...messageProps}>
                    <Linkify>{message.body.elementText.text}</Linkify>
                </MessageBodyContainer>:<MessageBodyContainer  {...messageProps}>
                        <div dangerouslySetInnerHTML={{__html:message.body.elementText.text}}></div>
                </MessageBodyContainer>
                
                
            }
        </MessageBody>:null}

        {isEvent?<EventBody  className="event-body" isCustomer={isCustomer}>
            <EventText>
            
            <span>{ message.body.elementText.text  }</span>
            { (message?.senderType === "PARTICIPANT_ADDED") ? 
                " " + config?.ChatBox?.JoinChatMessage
            : null
            }
            {(message?.senderType === "PARTICIPANT_REMOVED") ? 
                " " + config?.ChatBox?.LeaveChatMessage
            : null
            }
            </EventText>
            {<EventTime> { dateString} </EventTime>}
        </EventBody>:null}
        {isChip ? <RichMedia>
            {actionList?.map((button, index) =>(
                <PostbackButton
                 key={index}
                 isReplied={replied}
                 title={button.text}
                 payload={button.payload}
                 onPostback={null}
                 theme={'dafabet'}
                 disabled={replied}
                />
            ))}
            </RichMedia>: null}

            {isImage ? <RichMediaUpload payload= {actionList}></RichMediaUpload> : null}
            {isDOB ? <DOBInputSeparate/> : null}
            {isInputText? <UsernameInput/>: null}

        </MessageWrapper>
        
    </MessageComponent>
    )
}


export default Message;
